import React from 'react'
import { Formik, Field, Form } from 'formik'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'

import { AddressAutocomplete } from '../../../AddressAutocomplete/AddressAutocomplete'
import Button from '../../../Button/Button'
import CloseButton from '../../../CloseButton/CloseButton'
import { dataByTypename } from '../../../../utils/apollo-helpers'
import { DeleteSavedAddress } from '../DeleteSavedAddress/DeleteSavedAddress'
import Error from '../../../Error/Error'
import Input from '../../../Form/Input/Input'
import { stripDeliveryInfo } from '../../../../utils/address-helpers'
import { useUpdateSavedAddress } from '../../../use-saved-addresses/use-saved-addresses'

import './SavedAddressEditor.css'

export const SavedAddressEditor = ({ savedAddress, onClose }) => {
  const [ updateMutation ] = useUpdateSavedAddress()

  const onSuccess = ({ action, resetForm }) => {
    toast(`Address ${action} Successfully!`)
    onClose()
    resetForm(initialValues)
  }

  const { name = '', guid } = savedAddress
  const deliveryInfo = Object.entries(savedAddress.deliveryInfo).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value || '' }),
    {}
  )
  const { notes, address2 } = deliveryInfo

  const initialValues = {
    name,
    deliveryInfo,
    notes,
    address2
  }

  return (
    <div styleName='wrapper'>
      <Formik
        initialValues={initialValues}
        onSubmit={async (
          { name, deliveryInfo, notes, address2 },
          { setSubmitting, resetForm, setStatus }
        ) => {
          try {
            deliveryInfo = stripDeliveryInfo({
              ...deliveryInfo,
              notes,
              address2
            })
            const result = await updateMutation({
              variables: {
                input: { guid, name, deliveryInfo }
              }
            })
            const { UpdatePasswordError: error } = dataByTypename(
              result.data.updatePassword
            )

            if (error) {
              setStatus(error)
            } else {
              onSuccess({action: 'Updated', resetForm})
            }
          } catch (err) {
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {({
          status,
          setStatus,
          resetForm,
          isSubmitting
        }) => {
          return (
            <div styleName='wrapper'>
              <Form>
                <div styleName='close'>
                  <CloseButton onClick={onClose} />
                </div>
                {status && <Error error={status} />}
                <React.Fragment>
                  <Field
                    label='Address Label'
                    id='address_name'
                    name='name'
                    type='text'
                    component={Input}
                  />
                  <Field
                    id='delivery_info'
                    name='deliveryInfo'
                    component={AddressAutocomplete}
                  />
                  <Field
                    id='delivery_info_address_2'
                    type='text'
                    label='Apt./Suite no.'
                    name='address2'
                    component={Input}
                  />
                  <Field
                    id='delivery_info_notes'
                    type='text'
                    label='Delivery Instructions'
                    name='notes'
                    component={Input}
                  />
                  <DeleteSavedAddress
                    onCompleted={() => onSuccess({ action: 'Deleted', resetForm })}
                    onError={setStatus}
                    savedAddress={savedAddress}
                  />
                  <Button
                    loading={isSubmitting}
                    style='primary'
                    type='submit'
                    responsive>
                    Update My Address
                  </Button>
                </React.Fragment>
              </Form>

            </div>
          )
        }}
      </Formik>
    </div>
  )
}

SavedAddressEditor.propTypes = {
  savedAddress: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
}
